import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import { useCurrentTracklog, useAnalytics } from 'ff/debrief/hooks';
import { useDebriefModal } from 'ff/debrief/modalManager';
import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';

const ShareModal = () => {
    const { isOpen, close } = useDebriefModal('Share');
    const [isCopied, setIsCopied] = React.useState(false);
    const { logShareButtonClicked } = useAnalytics();

    const { tracklog: tl, shareUrl } = useCurrentTracklog();

    const handleClose = () => {
        setIsCopied(false);
        close();
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            setIsCopied(true);
        });
        logShareButtonClicked();
    };

    if (!tl) return null;
    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DebriefDialogTitle onClose={handleClose}>Share</DebriefDialogTitle>
            <DialogContent>
                <Typography>Copy link to share:</Typography>
                <TextField
                    variant="standard"
                    multiline
                    size="small"
                    fullWidth
                    color="primary"
                    sx={{
                        color: '#3498DB',
                        '& .MuiInputBase-input': {
                            color: '#3498DB',
                            fontWeight: 700,
                        },
                    }}
                    value={shareUrl}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <Button
                                    size="small"
                                    variant="contained"
                                    sx={{ mb: '5px' }}
                                    color={isCopied ? 'success' : 'primary'}
                                    onClick={handleCopyClick}
                                >
                                    {isCopied ? 'Copied!' : 'Copy Link'}
                                </Button>
                            </InputAdornment>
                        ),
                    }}
                />
            </DialogContent>
        </Dialog>
    );
};

export default ShareModal;
